import React from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { useMutation } from "@apollo/client";
import { LANGUAGE_CREATE } from "graphql/mutation/language-gql";
import { GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED } from "graphql/query/language-gql";
import { errorNotification, successNotification } from "components/request-result";
import { Localize } from "components/service";
import LanguageConst from "../../language-const";
import FormItems from "../fields";


const basePath = LanguageConst.basePath;

const normalizeValues = (values) => ({
    ...values,
    label: String(values.label || '').trim(),
    slug: String(values.slug || '').trim().toLowerCase(),
});

const LanguageCreateForm = () => {

    const history = useHistory();
    const [ form ] = Form.useForm();

    const [ languageCreateRequest, { loading } ] = useMutation(LANGUAGE_CREATE, {
        refetchQueries: [ GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED ],
        update(cache, { data }) {
            const {
                languageCreate: {
                    label,
                    message
                }
            } = data;

            successNotification({
                title: label,
                description: message
            });

            if (data?.languageCreate?.language?.id)
            {
                history.push(`${ basePath }`);
            }
        },
        onError(error) {
            errorNotification(error);
        }
    });

    return (
        <Form
            key="create-language"
            layout="vertical"
            className="language-form"
            form={ form }
            initialValues={ { status: true } }
            onFinish={ (values) => {
                languageCreateRequest({
                    variables: {
                        input: normalizeValues(values)
                    }
                }).catch((error) => {
                    errorNotification(error);
                });
            } }
        >
            <Form.Item
                name="label"
                label={ <Localize>FORMS.Input_Label_LanguageLabel</Localize> }
                rules={ [ { required: true, message: <Localize>FORM_RULES.Required_LanguageLabel</Localize> } ] }
            >
                <Input placeholder={ Localize({ children: "FORMS.Input_Placeholder_LanguageLabel" }).props.children } />
            </Form.Item>

            <Form.Item
                name="slug"
                label={ <Localize>FORMS.Input_Label_LanguageSlug</Localize> }
                rules={ [ { required: true, message: <Localize>FORM_RULES.Required_LanguageSlug</Localize> } ] }
            >
                <Input placeholder={ Localize({ children: "FORMS.Input_Placeholder_LanguageSlug" }).props.children } />
            </Form.Item>

            <FormItems.StatusSelect />

            <div className="form-btn-holder">
                <Button
                    className="btn-right"
                    loading={ loading }
                    disabled={ loading }
                    type="primary"
                    htmlType="submit"
                >
                    <Localize>LANGUAGE.Button_Text_Create</Localize>
                </Button>
            </div>
        </Form>
    );
};

export default LanguageCreateForm;
